import { useHubEvent } from "./useHubEvent";

export { useHubEvent };
